import { connect } from 'react-redux';

import { IReduxState, TThunkDispatch } from '../../types/redux';
import { dealTypeFromJsonQuery, FDealType } from '../../utils/category';
import { setDealType } from '../../actions/filters';
import { FiltersTabs, IFiltersTabProps, IFiltersTabsProps } from '../../components/FiltersTabs';
import { DEAL_TYPE_NAMES } from '../../constants/dealType';
import { ESpecialType, trackDealTypeTabClick, trackSpecialTabClick } from './tracking';
import { EPageKind } from '../../types/page';
import * as React from 'react';
import { setMortgageTabActive } from '../../actions/mortgage';

type TFiltersTabsStateProps = {
  currentDealType: FDealType,
  isMortgageSelected: Boolean,
  pageKind: EPageKind,
};
type TFilterOfferTypeDispatchProps = {
  onDealTypeSelect(event: React.MouseEvent<HTMLAnchorElement>, dealType: FDealType, pageKind: EPageKind): void,
  onValuationSelect(pageKind: EPageKind): void,
  onMortgageSelect(event: React.MouseEvent<HTMLAnchorElement>, pageKind: EPageKind): void,
};

export function mapStateToProps(state: IReduxState): TFiltersTabsStateProps {
  return {
    currentDealType: dealTypeFromJsonQuery(state.filters.jsonQuery),
    isMortgageSelected: state.mortgage.isMortgageTabActive,
    pageKind: state.page.kind,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    onDealTypeSelect: (event: React.MouseEvent<HTMLAnchorElement>, dealType: FDealType, pageKind: EPageKind) => {
      event.preventDefault();
      dispatch(setDealType(dealType));
      dispatch(setMortgageTabActive(false));
      trackDealTypeTabClick(pageKind, dealType);
    },
    onMortgageSelect: (event: React.MouseEvent<HTMLAnchorElement>, pageKind: EPageKind) => {
      event.preventDefault();
      dispatch(setMortgageTabActive(true));
      trackSpecialTabClick(pageKind, ESpecialType.Mortgage);
    },
    onValuationSelect: (pageKind: EPageKind) => {
      trackSpecialTabClick(pageKind, ESpecialType.Valuation);
    },
  };
}

export function mergeProps(stateProps: TFiltersTabsStateProps, dispatchProps: TFilterOfferTypeDispatchProps)
  : IFiltersTabsProps {
  const {currentDealType, isMortgageSelected, pageKind} = stateProps;
  const {onDealTypeSelect, onValuationSelect, onMortgageSelect} = dispatchProps;
  const items: IFiltersTabProps[] = [
    {
      label: DEAL_TYPE_NAMES[FDealType.Sale],
      url: '/kupit/',
      isSelected: currentDealType === FDealType.Sale && !isMortgageSelected,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onDealTypeSelect(event, FDealType.Sale, pageKind);
      },
    },
    {
      label: DEAL_TYPE_NAMES[FDealType.RentLongterm],
      url: '/snyat/',
      isSelected: currentDealType === FDealType.RentLongterm && !isMortgageSelected,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onDealTypeSelect(event, FDealType.RentLongterm, pageKind);
      },
    },
    {
      label: DEAL_TYPE_NAMES[FDealType.RentDaily],
      url: '/posutochno/',
      isSelected: currentDealType === FDealType.RentDaily && !isMortgageSelected,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onDealTypeSelect(event, FDealType.RentDaily, pageKind);
      },
    },
    {
      label: 'Оценить квартиру', url: '/kalkulator-nedvizhimosti/', isSelected: false,
      clickHandler: () => {
        onValuationSelect(pageKind);
      },
    },
    {
      label: 'Ипотека', url: '/mortgage/', isSelected: isMortgageSelected,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onMortgageSelect(event, pageKind);
      },
    },
  ];

  return {items};
}

export const FiltersTabsContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(FiltersTabs);
